import {addSeconds, format, formatDistance, formatDistanceToNow, fromUnixTime, parseISO} from 'date-fns'
import {de} from 'date-fns/locale'

export const dateHelper = {

  methods: {
    shortDate(date) {
      return format(parseISO(date), 'dd.MM.yyyy');
    },
    longDate(date) {
      return format(parseISO(date), 'dd.MM.yyyy H:mm');
    },
    humanDate(date) {
      return formatDistance(parseISO(date), new Date(), {locale: de});
    },
    formatDistanceToNow(seconds) {
      return formatDistanceToNow(addSeconds(new Date(), seconds), {locale: de});
    },
    fromUnixTime(unixTime) {
      return format(fromUnixTime(unixTime), 'dd.MM.yyyy')
    }
  }
};
